/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import IconComponent from 'ui/src/components/Icon';
import MobileFlyout from 'ui/src/components/MobileFlyout';

import addUrlHostName from 'ui/src/utils/addUrlHostname';
import { MobileMenuItemProps } from './_props';

import useMobileHeaderTheme from './themes';

/**
 * MobileMenuItem Component
 */

function MobileMenuItem({ menuItem, mobileMenuActiveItem, toggleMobileMenuActiveItem }: MobileMenuItemProps) {
  const {
    mobileMenuNavListItemClasses,
    mobileMenuNavListItemActiveClasses,
    mobileMenuNavListItemNameClasses,
    mobileMenuDropdownIconProps,
  } = useMobileHeaderTheme();

  return (
    <li
      className={twMerge(mobileMenuNavListItemClasses, {
        [mobileMenuNavListItemActiveClasses]: menuItem.id === mobileMenuActiveItem,
      })}
    >
      {!menuItem.children.length && (
        <a href={addUrlHostName(menuItem.path)} className={mobileMenuNavListItemNameClasses}>
          {menuItem.label}
        </a>
      )}

      {!!menuItem.children.length && (
        <button
          type="button"
          className={mobileMenuNavListItemNameClasses}
          onClick={() => toggleMobileMenuActiveItem(menuItem.id)}
        >
          {menuItem.label}

          <IconComponent
            iconName={menuItem.id === mobileMenuActiveItem ? 'ExpandLess' : 'ExpandMore'}
            {...mobileMenuDropdownIconProps}
          />
        </button>
      )}

      <MobileFlyout subMenuItem={menuItem} mobileMenuActiveItem={mobileMenuActiveItem} />
    </li>
  );
}

/**
 * Exports
 */

export default MobileMenuItem;
